const React = require('react');
const ReactDOM = require('react-dom');
const FocusTrap = require('focus-trap-react');
//const displace = require('../../react-displace/src/displace.js');
//const noScroll = require('../../no-scroll');

import displace from '../../react-displace/src/displace.js';
import noScroll from '../../no-scroll';

class Modal extends React.Component {
    static defaultProps = {
        underlayProps: {},
        dialogId: 'react-aria-modal-dialog',
        underlayClickExits: true,
        escapeExits: true,
        underlayColor: 'rgba(0,0,0,0.5)',
        includeDefaultStyles: true,
        focusTrapPaused: false,
        scrollDisabled: true,

        alignMethod: null,  //{alignDialogByTarget}
        dialogStyle: null,
        initialFocusElement: null,
    };

    constructor(props) {
        super(props);
        if (!props.titleText && !props.titleId) {
            throw new Error(
                'react-aria-modal instances should have a `titleText` or `titleId`'
            );
        }

    }

    _alignDialogByTarget() {
        const paramContext = this.props.alignMethod.alignDialogByTarget;
        let targetClass = paramContext.targetClass;
        let width = paramContext.width;
        let align = paramContext.align ?? 'left';

        let dialogNode = this.dialogNode;
        let targetEl = document.getElementsByClassName(targetClass);

        if (!dialogNode) return;
        if (targetEl && targetEl.length == 0) return;


        let widthShift = null;
        if (width === 'match') {
            dialogNode.style.width = `${targetEl[0].offsetWidth}px`;
        } else {
            if (width != null) {
                dialogNode.style.width = `${width}`;
                widthShift = width;
            }
        }

        if (align === 'left') {
            dialogNode.style.transform = `translate(${targetEl[0].offsetLeft}px,${targetEl[0].offsetTop}px)`;
        } else if (align === 'right') {

            if (widthShift !== null) {
                dialogNode.style.transform = `translate( calc(${targetEl[0].offsetLeft}px + ${targetEl[0].offsetWidth}px - ${widthShift}),${targetEl[0].offsetTop}px)`;
            } else {
                dialogNode.style.transform = `translate(${targetEl[0].offsetLeft}px,${targetEl[0].offsetTop}px)`;
            }
        }

    }

    onresized = () => {
        this._alignDialogByTarget();
    }

    _addResizedListener() {
        window.addEventListener('onresized', this.onresized);
    }

    _removeResizedListener() {
        window.removeEventListener('onresized', this.onresized);
    }

    componentDidMount() {
        if (this.props.onEnter) {
            this.props.onEnter();
        }

        // Timeout to ensure this happens *after* focus has moved
        const applicationNode = this.getApplicationNode();
        setTimeout(() => {
            if (applicationNode) {
                applicationNode.setAttribute('aria-hidden', 'true');
            }
        }, 0);

        if (this.props.escapeExits) {
            this.addKeyDownListener();
        }

        if (this.props.alignMethod) {
            if (this.props.alignMethod.alignDialogByTarget) {
                this._addResizedListener();
                this._alignDialogByTarget();
                // window.addEventListener('resize', debouncedChangeHandler);
                //
                // return () => {
                //   window.removeEventListener('resize', debouncedChangeHandler);
                //   debouncedChangeHandler.cancel();
                // };
                //
            }
        }

        if (this.props.scrollDisabled) {
            noScroll.on();
        }

        if (this.props.initialFocusElement) {
            if (typeof window !== "undefined") {
                /// browser code

                window.setTimeout( ()=>
                {
                    if (this.props.initialFocusElement[0] === "#") {
                        let id = this.props.initialFocusElement.replace(/#(\w+)/, '$1');
                        document.getElementById(id)?.focus();
                    } else {
                        let id = this.props.initialFocusElement.replace(/[.](\w+)/, '$1');
                        document.getElementsByClassName(id)?.[0]?.focus();
                    }
                }, 50);

            }

        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.scrollDisabled && !this.props.scrollDisabled) {
            noScroll.off();
        } else if (!prevProps.scrollDisabled && this.props.scrollDisabled) {
            noScroll.on();
        }

        if (this.props.escapeExits && !prevProps.escapeExits) {
            this.addKeyDownListener();
        } else if (!this.props.escapeExits && prevProps.escapeExits) {
            this.removeKeyDownListener();
        }
    }

    componentWillUnmount() {
        if (this.props.scrollDisabled) {
            noScroll.off();
        }
        const applicationNode = this.getApplicationNode();
        if (applicationNode) {
            applicationNode.setAttribute('aria-hidden', 'false');
        }
        this.removeKeyDownListener();
        this._removeResizedListener();
    }

    addKeyDownListener() {
        setTimeout(() => {
            document.addEventListener('keydown', this.checkDocumentKeyDown);
        });
    }

    removeKeyDownListener() {
        setTimeout(() => {
            document.removeEventListener('keydown', this.checkDocumentKeyDown);
        });
    }

    getApplicationNode = () => {
        if (this.props.getApplicationNode) return this.props.getApplicationNode();
        return this.props.applicationNode;
    };

    checkUnderlayClick = event => {
        if (
            (this.dialogNode && this.dialogNode.contains(event.target)) ||
            // If the click is on the scrollbar we don't want to close the modal.
            event.pageX > event.target.ownerDocument.documentElement.offsetWidth ||
            event.pageY > event.target.ownerDocument.documentElement.offsetHeight
        )
            return;
        this.exit(event);
    };

    checkDocumentKeyDown = event => {
        if (
            this.props.escapeExits &&
            (event.key === 'Escape' || event.key === 'Esc' || event.keyCode === 27)
        ) {
            this.exit(event);
        }
    };

    exit = event => {
        if (this.props.onExit) {
            this.props.onExit(event);
        }
    };

    render() {
        const props = this.props;

        let style = {};
        if (props.includeDefaultStyles) {
            style = {
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                zIndex: 1050,
                //overflowX: 'hidden',
                //overflowY: 'auto',
                WebkitOverflowScrolling: 'touch',
                textAlign: 'center'
            };

            if (props.underlayColor) {
                style.background = props.underlayColor;
            }

            if (props.underlayClickExits) {
                style.cursor = 'pointer';
            }
        }

        if (props.underlayStyle) {
            for (const key in props.underlayStyle) {
                if (!props.underlayStyle.hasOwnProperty(key)) continue;
                style[key] = props.underlayStyle[key];
            }
        }

        const underlayProps = {
            className: props.underlayClass,
            style: style,
            ref: function (el) {
                this.underlayNode = el;
            }.bind(this),
        };

        if (props.underlayClickExits) {
            underlayProps.onMouseDown = this.checkUnderlayClick;
        }

        for (const prop in this.props.underlayProps) {
            underlayProps[prop] = this.props.underlayProps[prop];
        }

        ///#region Dialog
        let dialogStyle = {};
        if (props.includeDefaultStyles) {
            dialogStyle = {
                display: 'inline-block',
                textAlign: 'left',
                top: 0,
                maxWidth: '100%',
                cursor: 'default',
                outline: props.focusDialog ? 0 : null
            };

            if (props.verticallyCenter) {
                dialogStyle.verticalAlign = 'middle';
                dialogStyle.top = 0;
            }
        }

        if (props.dialogStyle) {
            for (const key in props.dialogStyle) {
                if (!props.dialogStyle.hasOwnProperty(key)) continue;
                dialogStyle[key] = props.dialogStyle[key];
            }
        }

        const dialogProps = {
            key: 'b',
            ref: function (el) {
                this.dialogNode = el;
            }.bind(this),
            role: props.alert ? 'alertdialog' : 'dialog',
            id: props.dialogId,
            className: props.dialogClass,
            style: dialogStyle
        };
        if (props.titleId) {
            dialogProps['aria-labelledby'] = props.titleId;
        } else if (props.titleText) {
            dialogProps['aria-label'] = props.titleText;
        }
        if (props.focusDialog) {
            dialogProps.tabIndex = '-1';
        }

        // Apply data- and aria- attributes passed as props
        for (let key in props) {
            if (/^(data-|aria-)/.test(key)) {
                dialogProps[key] = props[key];
            }
        }
        //#endregion

        const childrenArray = [
            React.createElement('div', dialogProps, props.children)
        ];

        let verticalCenterStyle = {};
        if (props.includeDefaultStyles) {
            verticalCenterStyle = {
                display: 'inline-block',
                height: '100%',
                verticalAlign: 'middle'
            };
        }

        const verticalCenterHelperProps = {
            key: 'a',
            style: verticalCenterStyle
        };

        if (props.verticallyCenter) {
            childrenArray.unshift(
                React.createElement('div', verticalCenterHelperProps)
            );
        }

        if (props.focusDialog) {
            const focusTrapOptions = props.focusTrapOptions || {};
            if (props.focusDialog || props.initialFocus) {
                focusTrapOptions.initialFocus = props.focusDialog
                    ? `#${this.props.dialogId}`
                    : props.initialFocus;
            }
            focusTrapOptions.escapeDeactivates = props.escapeExits;

            return React.createElement(
                FocusTrap,
                {
                    focusTrapOptions,
                    paused: props.focusTrapPaused
                },
                React.createElement('div', underlayProps, childrenArray)
            );
        } else {
            return React.createElement('div', underlayProps, childrenArray)
        }
    }
}

const DisplacedModal = displace(Modal);

DisplacedModal.renderTo = function (input) {
    return displace(Modal, {renderTo: input});
};

export default DisplacedModal;
//module.exports = DisplacedModal;
